import { Injectable } from '@angular/core';

import { isTipoPessoaCentralCompras } from '../../../tipo';

/** Service que valida o acessos a funcionalidades referentes as centrais de compras dos clientes */
@Injectable({
    providedIn: 'root'
})
export class ClienteCentralCompraAuthGuardService {

    /** Verifica se pode inserir um novo participante em uma central de compras */
    canInsertParticipante(tipoPessoa: number, idClienteCentralCompra: number): boolean {
        // Somente quando não for uma central de compras e ainda não tiver sido adicionado como participante em alguma central de compras
        return !isTipoPessoaCentralCompras(tipoPessoa) && !idClienteCentralCompra;
    }

    /** Verficar se pode atualizar uma central de compras */
    canEdit(tipoPessoa: number): boolean {
        // Somente quando for uma central de compras
        return isTipoPessoaCentralCompras(tipoPessoa);
    }
}
